<template>
  <div class="tariffTerms">
    <p class="m-b-40" style="margin-top:0px;margin-bottom:14px;text-align:center;font-size:22px;">
      <span style="font-family:'黑体';font-weight:bold;">《资费条款》</span>
    </p>
    <p class="m-b-20">根据《律小购用户服务协议》第四章“资费”的约定，律小购资费标准如下：</p>
    <p
      class="m-b-20"
    >1、律小购软件（以下简称“本软件”）向律师（含律师商务助理和律师助理）用户收取资费，向法律服务消费者（律师的当事人）用户永久免费。律师用户注册本软件账户后，从注册之日起享有不低于3个月、不长于6月的试用期。</p>
    <p
      class="m-b-20"
    >2、试用期届满后，律师（含律师商务助理和律师助理）用户需要支付软件使用软件基础服务费。标准价格为执业律师（含律师商务助理和律师助理）2999元/年/人（账号）、3999元/两年/人人（账号）、4999元/3年/人（账号）。
    本软件不单独收取律所账号费用，律所行政、财务、内勤岗位人员免费赠送用户账号使用权。</p>
    <p
      class="m-b-20"
    >2、软件基础服务费在2022年度（2022.1.1至2022.12.31），执行优惠价格方案为：律师用户为账号（含999元/年/人（账号）、1488元/两年/人（账号）、1998元/三年/人（账号）。
    律所账户以及行政、财务、内勤岗位人员赠送免费用户账户使用权。
    在2022年度（2022.1.1至2022.12.31）一次性购买团购价：同一律所全员或者10人（含）以上888元/年/人（账号）、1288/两年/人（账号）、1698元/三年/人（账号）。律所账户以及行政、财务、内勤岗位人员赠送免费用户账号使用权。</p>
    <p
      class="m-b-20"
    >3、从2023年度（含）起，在2022年度执行优惠价格方案标准基础上，每年度分别上调400元/年/人（账号）、700元/两年/人（账号）、1000元/三年/人（账号），直到达到本资费条款第2条约定的标准价格为准。
    2023年度（含）起的团购价格方案，由当地的经销商在权限范围内自主确定，但不得低于2022年度的团购价格标准。</p>
    <p
      class="m-b-20"
    >4、律小购同意，付费用户在付费使用期限届满后续费的，按照首次付费标准续费。</p>
    <p
      class="m-b-20"
    >5、律师用户定制服务费根据用户的定制需求另行协商确定。</p>
    <p
      class="m-b-20"
    >6、本公司的资费收款账号为:
    账户名称：律购人工智能科技（重庆）有限公司
    开户行：中国建设银行股份有限公司重庆北碚城南支行
    账号：5005 0109 0041 0000 0762
    本公司未授权其他任何主体享有收取任何款项的权利，在支付价款时请注意防范自身风险。</p>
  </div>
</template>


<style lang="scss">
@import './utils.scss';
.tariffTerms {
  padding: 55px 55px;
  font-size: 28px;
  font-family: PingFang SC;
  color: #333333;
  line-height: 46px;
  background-color: #fff;
  .title {
    font-size: 32px;
    font-weight: 400;
    color: #4c4c4c;
  }
}
</style>